import '@/assets/css/app.scss';
import SvgIcon from '@/components/icons/SvgIcon.vue';
import clickOutside from '@/plugins/clickOutside';
import { components, plugins } from '@/plugins/elementPlus';
import helpers from '@/plugins/helpers';
import i18n from '@/plugins/i18n';
import '@/plugins/vee-validate';
import axios from 'axios';
import { createApp } from 'vue';
import VueAxios from 'vue-axios';
import App from './App.vue';
import router from './router';
import { store, key } from './store';

const initSentry = () => import('@/plugins/sentry');

const app = createApp(App)
  .use(store, key)
  .use(router)
  .use(i18n)
  .use(VueAxios, axios)
  .use(helpers)
  .directive('clickOutside', clickOutside);

app.component('svg-icon', SvgIcon);

// Load element plus components and plugins
components.forEach((component) => {
  app.component(component.name!, component);
});

plugins.forEach((plugin) => {
  app.use(plugin);
});

if (import.meta.env.MODE === 'production') {
  initSentry().then((init) => init.default(app, router));
}

app.mount('#app');
